import { SEOCategoryDetails } from './seo-category-details-response.interface';

export const PRUNED_SEO_CATEGORY_DETAILS_FIELDS = [
  'attr',
  'breadCrumbDetails',
  'categoryType',
  'catgroupId',
  'dsgClearance',
  'id',
  'identifier',
  'longDescription',
  'metaDesc',
  'metaKeyword',
  'name',
  'pageType',
  'redirect',
  'seoUrl',
  'title',
] as const satisfies readonly (keyof SEOCategoryDetails)[];

export type PrunedSEOCategoryDetails = Pick<
  SEOCategoryDetails,
  (typeof PRUNED_SEO_CATEGORY_DETAILS_FIELDS)[number]
>;
